// extracted by mini-css-extract-plugin
module.exports = {"marginBottom2":"time-out_marginBottom2__33uWE","marginBottom4":"time-out_marginBottom4__3VQPD","error":"time-out_error__1DuQC"};